import { format } from "date-fns";
import moment from "moment";
import intl from "react-intl-universal";
import { downloadCsv } from "../../../Components/Molecules/GridHistory/gridFilterUtils";
import {
  EMPTY_DATE_AMOUNT_SUB_ACCOUNT_FILTERS,
  apiFilterObjFromFilters,
  applyDateAmountSubAccountClientFilters,
  buildDateAmountSubAccountFilterTags,
  filtersFromApiFilterObj,
  hasActiveDateAmountSubAccountFilters,
  isDateAmountSubAccountChipFilterActive,
  removeDateAmountSubAccountFilterTag,
} from "../../../Components/Molecules/GridHistory/dateAmountSubAccountFilters";
import { estimateExtractTotal, flattenTransactionDayGroups, regroupTransactionsByDay } from "../Extract/extractFilters";

export { flattenTransactionDayGroups, regroupTransactionsByDay, estimateExtractTotal };

export const EMPTY_REFUNDS_FILTERS = { ...EMPTY_DATE_AMOUNT_SUB_ACCOUNT_FILTERS };

export {
  apiFilterObjFromFilters as refundsFilterObjFromFilters,
  buildDateAmountSubAccountFilterTags as buildRefundsFilterTags,
  filtersFromApiFilterObj as filtersFromRefundsFilterObj,
  hasActiveDateAmountSubAccountFilters as hasActiveRefundsFilters,
  isDateAmountSubAccountChipFilterActive as isRefundsChipFilterActive,
  removeDateAmountSubAccountFilterTag as removeRefundsFilterTag,
  applyDateAmountSubAccountClientFilters as applyRefundsClientFilters,
};

export const exportRefundsCsv = (items) => {
  const headers = [
    intl.get("grid.date"),
    intl.get("grid.entry"),
    intl.get("grid.value"),
  ];

  const rows = items.map((item) => {
    const amount = (Number(item.amount) || 0) / 100;
    return [
      moment(item.created_at).format("DD/MM/YYYY HH:mm"),
      item.description || "",
      amount.toFixed(2).replace(".", ","),
    ];
  });

  downloadCsv(headers, rows, `estornos-${format(new Date(), "yyyy-MM-dd")}.csv`);
};
